import { render, staticRenderFns } from "./UpSwitch.vue?vue&type=template&id=2207330e&scoped=true"
import script from "./UpSwitch.vue?vue&type=script&lang=js"
export * from "./UpSwitch.vue?vue&type=script&lang=js"
import style0 from "./UpSwitch.vue?vue&type=style&index=0&id=2207330e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2207330e",
  null
  
)

export default component.exports